import React, { useContext, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  FaChair,
  FaListAlt,
  FaReceipt,
  FaHamburger,
  FaUsers,
  FaUserCircle,
  FaSignOutAlt,
  FaHistory,
  FaChartBar,
  FaFileInvoiceDollar,
  FaMoon,
  FaSun,
  FaBars,
  FaTasks,      // Tablero
  FaBoxOpen,    // Inventario insumos
  FaExchangeAlt,// Movimientos de inventario
  FaClipboardList, // Recetas de productos
} from "react-icons/fa";
import { AuthContext } from "../context/AuthContexto";
import { ThemeContext } from "../context/ThemeContexto";
import logo from "../logo.png";

function Navbar() {
  const { usuario, cerrarSesion } = useContext(AuthContext);
  const { theme, toggleTheme } = useContext(ThemeContext);
  const [openMenu, setOpenMenu] = useState(false); // menú perfil
  const [openMobileNav, setOpenMobileNav] = useState(false); // menú principal móvil
  const navigate = useNavigate();

  if (!usuario) return null;

  const handleLogout = () => {
    cerrarSesion();
    localStorage.clear();
    navigate("/login");
  };

  const navLinkClass = ({ isActive }) =>
    [
      "flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-colors",
      isActive
        ? "bg-slate-700 text-amber-300 shadow"
        : "text-slate-200 hover:text-amber-300 hover:bg-slate-700/50",
    ].join(" ");

  return (
    <header
      className="
        relative
        w-full h-[75px]
        flex items-center
        px-3 sm:px-5
        shadow-[0_4px_18px_rgba(0,0,0,0.4)]
        bg-slate-800 text-slate-100
        dark:bg-slate-950
        transition-colors
        z-50
      "
    >
      <div className="w-full flex items-center justify-between gap-3">
        {/* Logo + botón hamburguesa (mobile) */}
        <div className="flex items-center gap-2">
          <NavLink to="/pedidos" className="flex items-center">
            <img
              src={logo}
              alt="Delis Logo"
              className="h-10 sm:h-[60px] w-auto mr-1 sm:mr-2 drop-shadow-md"
            />
          </NavLink>

          {/* Botón hamburguesa solo en móvil */}
          <button
            onClick={() => setOpenMobileNav((prev) => !prev)}
            className="
              md:hidden
              flex items-center justify-center
              w-9 h-9
              rounded-full border border-slate-600
              bg-slate-700/40
              text-slate-100
              hover:bg-slate-700
              transition-colors
            "
          >
            <FaBars size={18} />
          </button>
        </div>

        {/* Menú central - SOLO escritorio/tablet */}
        <nav className="hidden md:flex flex-1 justify-center items-center flex-wrap gap-2">
          {(usuario?.rol === "ADMIN" || usuario?.rol === "MESERO") && (
            <NavLink to="/mesas" className={navLinkClass}>
              <FaChair /> <span>Mesas</span>
            </NavLink>
          )}

          {/* Lista de pedidos */}
          <NavLink to="/pedidos" className={navLinkClass}>
            <FaListAlt /> <span>Pedidos</span>
          </NavLink>

          {/* Tablero de pedidos */}
          <NavLink to="/pedidos/tablero" className={navLinkClass}>
            <FaTasks /> <span>Tablero</span>
          </NavLink>

          {usuario?.rol === "ADMIN" && (
            <NavLink to="/productos" className={navLinkClass}>
              <FaHamburger /> <span>Productos</span>
            </NavLink>
          )}

          {(usuario?.rol === "ADMIN" || usuario?.rol === "CAJERO") && (
            <NavLink to="/facturas" className={navLinkClass}>
              <FaReceipt /> <span>Facturas</span>
            </NavLink>
          )}

          {usuario?.rol === "ADMIN" && (
            <NavLink to="/usuarios" className={navLinkClass}>
              <FaUsers /> <span>Usuarios</span>
            </NavLink>
          )}
        </nav>

        {/* Controles derecha */}
        <div className="flex items-center gap-2 sm:gap-3 relative">
          {/* Modo oscuro */}
          <button
            onClick={toggleTheme}
            className="
              flex items-center justify-center
              w-8 h-8 sm:w-9 sm:h-9 rounded-full border border-slate-500
              bg-slate-700/30
              text-amber-300
              hover:bg-slate-700
              transition-colors
              shrink-0
            "
          >
            {theme === "light" ? <FaMoon size={16} /> : <FaSun size={16} />}
          </button>

          {/* Perfil */}
          <div className="relative">
            <button
              onClick={() => setOpenMenu((o) => !o)}
              className="
                flex items-center gap-1.5 sm:gap-2
                rounded-full border border-slate-600
                bg-slate-700/40 text-slate-100
                px-2.5 py-1.5 sm:px-3
                hover:bg-slate-700
                transition-colors
                max-w-[180px] sm:max-w-none
              "
            >
              <FaUserCircle size={20} />
              <span className="text-xs sm:text-sm flex flex-col sm:flex-row sm:gap-1 text-left sm:text-right">
                <span className="font-semibold truncate">
                  {usuario?.nombre}
                </span>
                <span className="text-[11px] sm:text-xs text-slate-400">
                  ({usuario?.rol})
                </span>
              </span>
            </button>

            {openMenu && (
              <div
                className="
                  absolute right-0 mt-2 w-64
                  rounded-xl border border-slate-700
                  bg-slate-800 text-slate-100
                  shadow-xl py-1
                  z-50
                "
              >
                {/* Historiales */}
                {usuario?.rol === "ADMIN" && (
                  <button
                    onClick={() => {
                      navigate("/pedidos/historial");
                      setOpenMenu(false);
                    }}
                    className="w-full text-left px-3 py-2 text-sm hover:bg-slate-700"
                  >
                    <FaHistory className="inline mr-2" />
                    Historial de Pedidos
                  </button>
                )}

                {(usuario?.rol === "ADMIN" || usuario?.rol === "CAJERO") && (
                  <button
                    onClick={() => {
                      navigate("/facturas/historial");
                      setOpenMenu(false);
                    }}
                    className="w-full text-left px-3 py-2 text-sm hover:bg-slate-700"
                  >
                    <FaFileInvoiceDollar className="inline mr-2" />
                    Historial de Facturas
                  </button>
                )}

                {usuario?.rol === "ADMIN" && (
                  <button
                    onClick={() => {
                      navigate("/dashboard");
                      setOpenMenu(false);
                    }}
                    className="w-full text-left px-3 py-2 text-sm hover:bg-slate-700"
                  >
                    <FaChartBar className="inline mr-2" />
                    Dashboard
                  </button>
                )}

                {/* Separador */}
                {usuario?.rol === "ADMIN" && (
                  <>
                    <div className="border-t border-slate-700 my-1" />
                    <p className="px-3 py-1 text-[11px] uppercase tracking-wide text-slate-400">
                      Inventario
                    </p>

                    {/* Inventario de insumos */}
                    <button
                      onClick={() => {
                        navigate("/inventario/insumos");
                        setOpenMenu(false);
                      }}
                      className="w-full text-left px-3 py-2 text-sm hover:bg-slate-700"
                    >
                      <FaBoxOpen className="inline mr-2" />
                      Inventario de Insumos
                    </button>

                    {/* Movimientos de inventario */}
                    <button
                      onClick={() => {
                        navigate("/inventario/movimientos");
                        setOpenMenu(false);
                      }}
                      className="w-full text-left px-3 py-2 text-sm hover:bg-slate-700"
                    >
                      <FaExchangeAlt className="inline mr-2" />
                      Movimientos de Inventario
                    </button>

                    {/* Recetas de productos */}
                    <button
                      onClick={() => {
                        navigate("/inventario/recetas");
                        setOpenMenu(false);
                      }}
                      className="w-full text-left px-3 py-2 text-sm hover:bg-slate-700"
                    >
                      <FaClipboardList className="inline mr-2" />
                      Recetas de Productos
                    </button>
                  </>
                )}

                <div className="border-t border-slate-700 my-1" />

                <button
                  onClick={() => {
                    setOpenMenu(false);
                    handleLogout();
                  }}
                  className="w-full text-left px-3 py-2 text-sm text-red-400 hover:bg-slate-700 hover:text-red-300"
                >
                  <FaSignOutAlt className="inline mr-2" />
                  Cerrar sesión
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Menú principal MOBILE desplegable */}
      {openMobileNav && (
        <nav
          className="
            md:hidden
            absolute top-[75px] inset-x-0
            bg-slate-900/95
            border-t border-slate-700
            shadow-xl
            z-40
          "
        >
          <div className="flex flex-col px-3 py-3 gap-1">
            {(usuario?.rol === "ADMIN" || usuario?.rol === "MESERO") && (
              <NavLink
                to="/mesas"
                className={(props) =>
                  navLinkClass(props) + " w-full justify-start"
                }
                onClick={() => setOpenMobileNav(false)}
              >
                <FaChair /> <span>Mesas</span>
              </NavLink>
            )}

            <NavLink
              to="/pedidos"
              className={(props) =>
                navLinkClass(props) + " w-full justify-start"
              }
              onClick={() => setOpenMobileNav(false)}
            >
              <FaListAlt /> <span>Pedidos</span>
            </NavLink>

            <NavLink
              to="/pedidos/tablero"
              className={(props) =>
                navLinkClass(props) + " w-full justify-start"
              }
              onClick={() => setOpenMobileNav(false)}
            >
              <FaTasks /> <span>Tablero</span>
            </NavLink>

            {usuario?.rol === "ADMIN" && (
              <NavLink
                to="/productos"
                className={(props) =>
                  navLinkClass(props) + " w-full justify-start"
                }
                onClick={() => setOpenMobileNav(false)}
              >
                <FaHamburger /> <span>Productos</span>
              </NavLink>
            )}

            {(usuario?.rol === "ADMIN" || usuario?.rol === "CAJERO") && (
              <NavLink
                to="/facturas"
                className={(props) =>
                  navLinkClass(props) + " w-full justify-start"
                }
                onClick={() => setOpenMobileNav(false)}
              >
                <FaReceipt /> <span>Facturas</span>
              </NavLink>
            )}

            {usuario?.rol === "ADMIN" && (
              <NavLink
                to="/usuarios"
                className={(props) =>
                  navLinkClass(props) + " w-full justify-start"
                }
                onClick={() => setOpenMobileNav(false)}
              >
                <FaUsers /> <span>Usuarios</span>
              </NavLink>
            )}
          </div>
        </nav>
      )}
    </header>
  );
}

export default Navbar;
